export default "__VITE_ASSET__Ccu0TS3F__"